import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { selectUserData } from '../../reducers/userDataReducer'
import './resident-events.scss'

const ResidentEvents = () => {
  const { t } = useTranslation(['resident-events'])
  const userData = useSelector(selectUserData)
  const userEmail = userData?.user?.email || ''

  return (
    <div className="resident-events">
      <div className="resident-events__container">
        <iframe
          src={`https://resivents.com/embed/events?email=${encodeURIComponent(userEmail)}`}
          className="resident-events__iframe"
          title={t('resident-events:title')}
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </div>
  )
}

export default ResidentEvents
